import "./Blogs.css";
import { ThemeProvider } from "@emotion/react";
import theme from "../../theme";
import ButtonYellow from "../ButtonGreen/ButtonGreen";
import blogging from "../../../assets/images/blogging.png";
import { Box, Card } from "@mui/material";
import Typography from "@mui/material/Typography";
import TextBox from "../TextBox/TextBox";

function Blogs() {
  return (
    <ThemeProvider theme={theme}>
      <div className="home">
        <svg
          viewBox="0 0 624 613"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="right-blob"
        >
          <path
            d="M3.30097 25.3858L8.16279 -1H624V589.409L536.028 609.022C524.169 611.666 512.056 613 499.906 613H496.314C448.972 613 404.112 591.822 374.026 555.268C353.084 529.825 340.6 498.483 338.313 465.609L334.068 404.583C327.545 310.821 254.522 235.341 161.027 225.72L152.764 224.87C114.415 220.924 78.5539 204.033 51.0884 176.98C11.0063 137.499 -6.89396 80.715 3.30097 25.3858Z"
            fill="#FEBD2F"
          />
        </svg>
        <div className="blogs-full-page">
          <div className="blogs-text-box">
            <span className="txt-yellow"> Blogs </span>
          </div>
          <img
            src={blogging}
            alt="Blogging"
            className="blogging"
          ></img>
          <Box className="blogs-card1">
            <TextBox>Find blogs about best food junctions, best resturants in your place and a lot more..</TextBox>

          </Box>
          <Box className="blogs-card2">
            <TextBox>Find one stop destination to write your food experiences and find other’s opinions.</TextBox>

          </Box>

          {/* <Box className='box'> */}
          {/* <Typography className="info">
            Find blogs about best food junctions, best resturants in your place and a lot more..
            </Typography>
          </Box>
          <Card className="blogs-card2">
            <Typography className="info">
            Find blogs about best food junctions, best resturants in your place and a lot more..
            </Typography>
          </Card>
          <Card className="blogs-card3">
            <Typography className="info">
            Find one stop destination to write your food experiences and find other’s opinions.
            </Typography>
          </Card> */}
          <div className="blogbtn">
            <ButtonYellow onClick={() => window.open('https://blog.encyclofoodia.com/', "_blank")}>Discover now</ButtonYellow>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default Blogs;
